<template>
  <!-- Hero -->
  <section class="hero" aria-labelledby="page-title">
    <div class="section__inner hero__inner">
      <h2 id="page-title">Contact</h2>
    </div>
  </section>

  <main class="page-content">
    <section class="inquiry-wrap" aria-label="상담 문의">
      <nav class="crumbs" aria-label="breadcrumb">
        <ol>
          <li>Contact</li>
          <li aria-current="page">상세</li>
        </ol>
      </nav>

      <form class="form-grid" @submit.prevent="goSave">
        <!-- Row 1 -->
        <div class="label">문의분야</div>
        <div class="field col-span-3">
          <div class="select-box">
            <select v-model="state.category" aria-label="문의분야 선택">
              <option value="" disabled>선택</option>
              <option value="자격/교육">자격/교육</option>
              <option value="진단/컨설팅">진단/컨설팅</option>
              <option value="협회/회원">협회/회원</option>
              <option value="기타">기타</option>
            </select>
            <span class="chev" aria-hidden="true">▾</span>
          </div>
        </div>

        <!-- Row 2 -->
        <div class="label">
          성명 <span class="req">*</span>
        </div>
        <div class="field col-span-3">
          <input
            v-model.trim="state.userName"
            type="text"
            autocomplete="name"
            :readonly="isMember"
            :class="{ 'input-readonly': isMember }"
            :placeholder="isMember ? '' : '성명을 입력하세요'"
            required
          />
        </div>

        <!-- Row 3 -->
        <div class="label">
          연락처 <span class="req">*</span>
        </div>
        <div class="field col-span-1">
          <input
            v-model.trim="state.phoneNumber"
            type="tel"
            inputmode="tel"
            autocomplete="tel"
            placeholder="예) 010-0000-0000"
            required
          />
        </div>

        <div class="label label-right">e-mail</div>
        <div class="field col-span-1">
          <input
            v-model.trim="state.email"
            type="email"
            autocomplete="email"
            placeholder="예) name@example.com"
          />
        </div>

        <!-- Row 4 -->
        <div class="label">제목</div>
        <div class="field col-span-3">
          <input v-model.trim="state.title" type="text" />
        </div>

        <!-- Row 5 -->
        <div class="label">내용</div>
        <div class="field col-span-3">
          <textarea v-model.trim="state.content" rows="10"></textarea>
        </div>

        <div class="divider col-span-4" role="separator" aria-hidden="true"></div>

        <div class="form-row2">
          <label for="title" class="form-label2">
            비밀번호 <span class="req" aria-hidden="true">*</span>
            <span class="sr-only">필수</span>
          </label>
          <input
            id="password"
            name="password"
            type="password"
            class="input2"
            placeholder="비밀번호를 입력하세요"
            v-model="state.password"
            aria-required="true"
            required
          />
        </div>

        <!-- Privacy -->
        <div class="privacy col-span-4">
          <h3 class="privacy-title">개인정보 수집 및 이용에 대한 안내</h3>

          <div class="privacy-box">
            <p>
              아래 내용은 상담 진행을 위해 필요한 최소한의 개인정보 수집·이용 안내입니다.
              자세한 사항은 관련 법령 및 내부 방침에 따릅니다.
            </p>
            <ol class="privacy-list">
              <li>정보수집의 이용 목적 : 상담 및 진행</li>
              <li>수집/이용 항목 : 이름, 연락처, 이메일, 내용 등</li>
              <li>보유 및 이용기간 : 상담 종료 후 6개월(정보주체의 삭제 요청 시 즉시)</li>
              <li>개인정보관리담당 : (예) 070-4489-7447</li>
            </ol>
          </div>

          <div class="agree-row">
            <label class="agree">
              <input v-model="state.agree" type="checkbox" />
              <span>개인정보 수집 및 이용에 동의합니다.</span>
            </label>

            <button type="button" class="btn-link" @click="openPolicy">전문보기</button>
          </div>

          <p v-if="error" class="error" role="alert">{{ error }}</p>
        </div>

        <!-- Actions -->
        <div class="actions col-span-4">
          <button type="submit" class="btn btn-primary">문의하기</button>
          <button type="button" class="btn btn-secondary" @click="handleCancel">취소하기</button>
        </div>
      </form>
    </section>
  </main>

  <!-- Policy Modal -->
  <teleport to="body">
    <div v-if="policyOpen" class="modal-overlay" role="dialog" aria-modal="true" aria-label="개인정보처리방침"
      @click.self="closePolicy">
      <div class="modal">
        <header class="modal-header">
          <h3 class="modal-title">개인정보처리방침</h3>
          <button type="button" class="modal-close" aria-label="닫기" @click="closePolicy">
            ×
          </button>
        </header>

        <div class="modal-body">
          <p>
            한국내부통제협회 (이하 "협회"라 함)는 이용자들의 개인정보보호를 매우 중요시하며, 이용자가 협회의
            서비스를 이용함과 동시에 온라인상에서 협회에 제공한 개인정보가 보호 받을 수 있도록 최선을 다하고
            있습니다. 이에 협회는 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한
            법률 등 정보통신서비스제공자가 준수하여야 할 관련 법규상의 개인정보보호 규정 및 정보통신부가 제정한
            개인정보보호지침을 준수하고 있습니다. 협회는 개인정보 보호정책을 통하여 이용자들이 제공하는 개인정보가
            어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다
          </p>

          <p>
            협회는 개인정보 보호정책을 홈페이지 첫 화면에 공개함으로써 이용자들이 언제나 용이하게 보실 수 있도록
            조치하고 있습니다.
          </p>

          <p>
            협회의 개인정보 보호정책은 정부의 법률 및 지침 변경이나 협회의 내부 방침 변경 등으로 인하여 수시로
            변경될 수 있고, 이에 따른 개인정보 보호정책의 지속적인 개선을 위하여 필요한 절차를 정하고 있습니다.
          </p>

          <p>협회의 개인정보 보호정책은 다음과 같은 내용을 담고 있습니다.</p>

          <h4 class="policy-h">가. 개인정보 수집에 대한 동의</h4>
          <p>협회는 이용자들이 협회의 개인정보 보호정책 또는 이용약관의 내용에 대하여 「동의」버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.</p>

          <h4 class="policy-h">나. 개인정보의 수집목적 및 이용목적</h4>
          <p>
            "개인정보"라 함은 생존하는 개인에 관한 정보로서 당해 정보에 포함되어 있는 성명 등의 사항에 의하여 당해
            개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 식별할 수 없더라도 다른 정보와 용이하게 결합하여
            식별할 수 있는 것을 포함)를 말합니다.
          </p>
          <p>
            대부분의 협회서비스는 별도의 사용자 등록이 없이 언제든지 사용할 수 있습니다. 그러나 협회는 이용자들에게 보다
            더 향상된 양질의 서비스를 제공하기 위하여 이용자 개인의 정보를 수집하고 있습니다.
          </p>
          <p>
            협회는 이용자의 사전 동의 없이는 이용자의 개인 정보를 공개하지 않으며, 수집된 정보는 아래와 같이 이용하고 있습니다.
          </p>

          <p><strong>첫째</strong>, 이용자들이 제공한 개인정보를 바탕으로 보다 더 유용한 서비스를 개발할 수 있습니다. 협회는 신규 서비스개발이나 컨텐츠의 확충시에 기존 이용자들이
            협회에 제공한 개인정보를 바탕으로 개발해야 할 서비스의 우선 순위를 보다 더 효율적으로 정하고, 협회는 이용자들이 필요로 할 컨텐츠를 합리적으로 선택하여 제공할 수 있습니다.</p>

          <p><strong>둘째</strong>, 협회가 제공하는 각종 정보 및 서비스 등은 대부분 무료입니다. 협회는 이러한 무료 서비스를 제공하기 위해서 광고를 게재하고 있는데, 이용자들에 대한
            정확한 개인정보를 바탕으로 각 서비스나 메뉴 등에 적절하게 광고와 내용들을 전달해 드릴 수 있으며, 이것은 궁극적으로 협회가 이용자 여러분들께 드리는 또 하나의 정보로서의 가치를 지니게
            됩니다. 협회는 광고주들로부터 광고를 받아 광고주들이 대상으로 하려는 이용자의 유형에 맞게 광고를 보여줄 뿐, 광고주들에게는 절대로 이용자들의 개인정보를 보여주거나 제공하지 않습니다.
          </p>

          <p><strong>셋째</strong>, 각 수집 정보 별 수집목적은 다음과 같습니다.</p>
          <ul class="policy-ul">
            <li>- 성명,아이디,비밀번호, 본인확인문답 : 서비스이용에 따른 민원사항의 처리를 위한 본인식별, 연령제한 서비스의 제공</li>
            <li>- ID : 불량회원의 부정한 이용 재발 방지</li>
            <li>- 이메일주소,전화번호 : 고지사항 전달, 본인 의사확인, 불만처리 등 의사소통 경로의 확보, 새로운 서비스, 정보 등 최신 정보안내</li>
            <li>- 은행계좌정보,신용카드정보,핸드폰번호,전화번호 : 유료정보이용에 대한 요금결제</li>
            <li>- 주소,전화번호 : 청구서, 자격증 등 배송시 정확한 배송지의 확보</li>
            <li>- 주소 : 우편물 발송</li>
            <li>- 그 외 선택항목 : 개인맞춤서비스를 제공하기 위한 자료</li>
            <li>- IP Address, 방문일시 : 불량회원의 부정 이용 방지와 비인가 사용 방지</li>
            <li>- 전화번호(유선, 휴대폰) : 가입 의사 확인, 가입 및 가입횟수 제한</li>
          </ul>

          <h4 class="policy-h">다. 협회가 수집하는 개인정보 항목 및 수집방법</h4>
          <p>
            협회는 이용자들이 회원서비스를 이용하기 위해 회원으로 가입하실 때 서비스 제공을 위한 필수적인 정보들을
            온라인상에서 입력 받고 있습니다. 회원 가입시에 받는 필수적인 정보는 이름, 이메일주소 등입니다. 또한 양질의
            서비스 제공을 위하여 이용자들이 선택적으로 입력할 수 있는 사항으로서 전화번호 등을 입력 받고 있습니다.
          </p>
          <p>
            또한 협회내에서의 설문조사나 이벤트 행사시 통계분석 등을 위해 선별적으로 개인정보 입력을 요청할 수 있습니다.
            그러나, 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지,
            정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않으며 부득이하게 수집해야 할 경우 이용자들의
            사전동의를 반드시 구할 것입니다. 그리고, 어떤 경우에라도 입력하신 정보를 이용자들에게 사전에 밝힌 목적 이외에
            다른 목적으로는 사용하지 않으며 외부로 유출하지 않습니다.
          </p>
          <p>
            협회에 광고를 게재하는 광고주나 검색 등의 각종 디렉토리에 링크가 되어 있는 웹사이트들이 이용자 여러분에 대하여
            개인적으로 식별할 수 있는 개인정보를 수집할 수도 있을 것입니다. 협회에 링크되어 있는 웹사이트들이 개인정보를
            수집하는 행위에 대해서는 본 "협회 개인정보 보호정책"이 적용되지 않음을 알려 드립니다.
          </p>

          <h4 class="policy-h">라. 협회가 수집하는 개인정보의 보유 및 이용기간</h4>
          <p>
            이용자가 협회의 회원으로서 협회에 제공하는 서비스를 이용하는 동안 협회는 이용자들의 개인정보를 계속적으로 보유하며
            서비스 제공 등을 위해 이용합니다. 다만, 아래의 "바. 이용자 자신의 개인정보 관리(열람,정정,삭제 등)에 관한 사항" 에서
            설명한 절차와 방법에 따라 회원 본인이 직접 삭제하거나 수정한 정보, 가입해지를 요청한 경우에는 해지되며 추후 적합한
            방법으로 회원이 다시 될 수 있습니다.
          </p>
          <p>
            귀하의 개인정보는 다음과 같이 개인정보의 수집목적 또는 제공받은 목적이 달성되면 파기하는 것을 원칙으로 합니다.
            그리고 상법,전자상거래등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는
            관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우 협회는 보관하는 정보를 그 보관의 목적으로만 이용하며
            보존기간은 아래와 같습니다.
          </p>
          <ul class="policy-ul">
            <li>- 대금결제 및 재화등의 공급에 관한 기록 : 5년</li>
            <li>- 회원의 불만 또는 분쟁처리에 관한 기록 : 3년</li>
          </ul>
          <p>협회는 귀중한 회원의 개인정보를 안전하게 처리하며, 유출의 방지를 위하여 다음과 같은 방법을 통하여 개인정보를 파기합니다.</p>
          <ul class="policy-ul">
            <li>- 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>
            <li>- 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없도록 삭제합니다.</li>
          </ul>

          <h4 class="policy-h">마. 협회가 수집한 개인정보의 공유 및 제공</h4>
          <p>
            협회는 이용자들의 개인정보를 "나. 개인정보의 수집목적 및 이용목적"에서 고지한 범위내에서 사용하며, 이용자의 사전 동의
            없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
          </p>
          <ul class="policy-ul">
            <li>- 이용자들이 사전에 공개에 동의한 경우</li>
            <li>- 서비스 제공에 따른 요금정산을 위하여 필요한 경우</li>
            <li>- 홈페이지에 게시한 협회 서비스 이용 약관 및 기타 회원 서비스 등의 이용약관 또는 운영원칙을 위반한 경우</li>
            <li>- 협회서비스를 이용하여 타인에게 정신적, 물질적 피해를 줌으로써 그에 대한 법적인 조치를 취하기 위하여 개인정보를 공개해야 한다고 판단되는 충분한 근거가 있는 경우</li>
            <li>- 기타 법에 의해 요구된다고 선의로 판단되는 경우 (ex. 관련법에 의거 적법한 절차에 의한 정부/수사기관의 요청이 있는 경우 등)</li>
            <li>- 통계작성,학술연구나 시장조사를 위하여 특정개인을 식별할 수 없는 형태로 광고주, 협력업체나 연구 단체 등에 제공하는 경우</li>
            <li>- 이용자의 서비스 이용에 따른 불만사항 및 문의사항(민원사항)의 처리를 위하여 파.항의 고객센터를 운영하는 전문업체에 해당 민원사항의 처리에 필요한 개인정보를 제공하는 경우
            </li>
          </ul>
          <p>
            그리고 협회는 새로운 기술개발이나 보다 나은 서비스의 제공을 위하여 이용자들의 개인정보를 공유할 수 있습니다.
            이 경우에도 정보수집 또는 정보제공 이전에 이용자들에게 개인정보를 공유할 기관이나 단체가 누구인지, 어떤 정보가 왜 필요한지,
            그리고 언제까지 어떻게 보호되고 관리되는지 알려드리고 동의를 구하는 절차를 거치게 되며, 이용자들의 동의가 없는 경우에는
            추가적인 정보를 임의로 수집하거나 공유하지 않습니다.
          </p>

          <h4 class="policy-h">바. 이용자 자신의 개인정보 관리(열람,정정,삭제 등)에 관한 사항</h4>
          <p>
            이용자는 언제든지 협회 홈페이지를 이용하여 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 가입 해지를 요청할 수도 있습니다.
            이용자들의 개인정보 조회 및 수정을 위해서는 협회 회원관리 메뉴에서 아이디와 비밀번호를 사용하여 로그인(LOG-IN)하면 되는데,
            아이디(ID) 및 이름을 제외한 모든 입력사항을 수정할 수 있습니다.
            이용자들은 협회서비스의 회원 아이디(ID)에 대하여 가입해지 또는 이용해지를 할 수 있으나 이로 인하여 모든 서비스를 이용할 수 없게 되는 것은 아니며,
            일부 서비스는 확인 가능합니다. 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 “라.협회가 수집하는 개인정보의 보유 및 이용기간”에 명시된 바에 따라
            처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
          </p>

          <h4 class="policy-h">사. 개인정보관련 의견수렴 및 불만처리에 관한 사항</h4>
          <p>
            협회는 개인정보보호와 관련하여 이용자 여러분들의 의견을 수렴하고 있으며 불만을 처리하기 위하여 모든 절차와 방법을 마련하고 있습니다.
            이용자들은 홈페이지 게시판에 본인의 의견을 적을 수 있습니다. 단, 내용이 비하발언이나 비방성 글일 경우로 판단될 경우 본인의 동의 없이 협회가 삭제 할 수 있습니다.
            또는 정부에서 설치하여 운영중인 아래의 기관에 불만처리를 신청할 수 있습니다.
          </p>
          <ul class="policy-ul">
            <li>- 개인정보 침해신고센터 (https://privacy.kisa.or.kr, 전화 1336)</li>
            <li>- 개인정보 분쟁조정위원회 (https://www.kopico.go.kr, 전화 1336)</li>
            <li>- 정보보호마크 인증위원회 (https://www.eprivacy.or.kr, 전화 02-580-0533)</li>
            <li>- 경찰청 (http://www.police.go.kr)</li>
          </ul>

          <h4 class="policy-h">아. 협회 개인정보 관리책임자 및 담당자의 소속-성명 및 연락처</h4>
          <p>
            협회는 귀하가 좋은 정보를 안전하게 이용할 수 있도록 최선을 다하고 있습니다. 개인정보를 보호하는데 있어 귀하께 고지한 사항들에 반하는 사고가 발생할 경우 개인정보관리책임자가 책임을
            집니다.
          </p>
          <p>
            이용자 개인정보와 관련한 아이디(ID)의 비밀번호에 대한 보안유지책임은 해당 이용자 자신에게 있습니다. 협회는 비밀번호에 대해 어떠한 방법으로도 이용자에게 직접적으로 질문하는 경우는
            없으므로 타인에게 비밀번호가 유출되지 않도록 각별히 주의하시기 바랍니다. 특히 "개인정보관련 기술적-관리적 대책"항에서 명시한 것과 같이 공공장소에서 온라인상에서 접속해 있을 경우에는
            더욱 유의하셔야 합니다. 협회는 개인정보에 대한 의견수렴 및 불만처리를 담당하는 담당자를 지정하고 있고, 연락처는 아래와 같습니다.
          </p>
          <p><strong>개인정보 관리 담당자</strong></p>
          <ul class="policy-ul">
            <li>- 이 름 : 최영규</li>
            <li>- 소속 / 직위 : 한국내부통제협회 / 사무총장</li>
            <li>- 전 화 번 호 : 070-4489-7447</li>
          </ul>

          <h4 class="policy-h">자. 협회 홈페이지 안내</h4>
          <ul class="policy-ul">
            <li>- 근무시간 : 평일 09:00~18:00 (토요일 및 일요일, 공휴일은 휴무)</li>
            <li>- 전화번호 : 070-4489-7447</li>
            <li>- 팩스 : 02-420-7243</li>
            <li>- 등기우편 : 서울시 금천구 가산디지털2로 108(뉴티캐슬 9층 905호) 한국내부통제협회 홈페이지 담당자 앞</li>
            <li>- 기타문의 : 홈페이지 안에서 메일 발송</li>
          </ul>
          <p>그 외 개인정보에 관한 상담이 필요한 경우에는 한국정보보호진흥원(KISA)에서 운영하는 개인정보 침해신고센터 (전화 : 1336)으로 문의하실 수 있습니다.</p>

          <h4 class="policy-h">차. 고지의 의무</h4>
          <p>현 개인정보보호정책의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다.</p>
          <p><strong>시행일자 : 2025년 8월 11일</strong></p>
        </div>

      </div>
    </div>
  </teleport>
</template>

<script setup>
import { reactive, ref, watch, onBeforeUnmount, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from 'vuex'
import { insertQuestion } from '@/api/qna'
import * as Utils from '@/common/util/util'

const checkUserId = computed(() => store.state.temp.userInfo)
const userInfo = computed(() => store.state.temp?.userInfo || null);
const userId = computed(() => userInfo.value?.userId || null);
const isMember = computed(() => !!userInfo.value?.userId); // 회원 여부

const router = useRouter();
const store = useStore()

const error = ref("");
const policyOpen = ref(false);

const state = reactive({
  category: "",
  userName: "",
  phoneNumber: "",
  email: "",
  title: "",
  content: "",
  password: "",
  agree: false,
});

const openPolicy = () => {
  policyOpen.value = true;
};

const closePolicy = () => {
  policyOpen.value = false;
};

const checkField = () => {
  if (Utils.isEmpty(state.category)) return alert("카테고리를 선택해주세요"), false;
  if (Utils.isEmpty(state.userName)) return alert("성명을 입력해주세요"), false;
  if (Utils.isEmpty(state.phoneNumber)) return alert("연락처를 입력해주세요"), false;
  if (Utils.isEmpty(state.title)) return alert("제목을 입력해주세요"), false;
  if (Utils.isEmpty(state.content)) return alert("내용을 입력해주세요"), false;
  if (Utils.isEmpty(state.password)) return alert("비밀번호를 입력해주세요"), false;
  if (!state.agree) return alert("개인정보 수집 및 이용에 동의해 주세요."), false;
  return true;
};

const goSave = async () => {
  if (!checkField()) return;
  if (!confirm("저장하시겠습니까?")) return;

  try {
    const params = {
      userId: userId.value,          // 회원이면 "U00088", 비회원이면 null
      title: state.title,
      content: state.content,
      password: state.password,
      category: state.category,
      phoneNumber: state.phoneNumber,
      email: state.email,
      userName: state.userName,
    };

    const resultVo = await insertQuestion(params);

    if (resultVo?.result === "ok") {
      alert(resultVo.resultMsg);
      router.push({ name: "qnamain" });
    } else {
      alert(resultVo?.resultMsg ?? "저장에 실패했습니다.");
    }
  } catch (e) {
    console.error("저장 중 오류 발생:", e);
    alert("저장 중 오류가 발생했습니다.");
  }
};


const handleCancel = () => {
  router.push({ name: 'qnamain' })
}

onMounted(() => {
  // 회원이면 자동 주입
  if (isMember.value) {
    state.userName = userInfo.value?.userName || "";
    state.phoneNumber = userInfo.value?.phoneNumber || "";
    state.email = userInfo.value?.email || "";
  }
});


watch(policyOpen, (open) => {
  // 모달 열릴 때 바디 스크롤 잠금
  document.body.style.overflow = open ? "hidden" : "";
});

// 컴포넌트가 사라질 때 overflow 복구(라우팅 이동 시 안전장치)
onBeforeUnmount(() => {
  document.body.style.overflow = "";
});

</script>

<style scoped>

.form-row2 { display: grid; gap: 10px; }
.form-label2 {
  font-weight: 700;
  color: #334155;
  font-size: 0.98rem;
}
.input2{
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 14px;
  background: #fff;
  color: #0f172a;
  font-size: 1rem;
  line-height: 1.5;
}

.inquiry-wrap,
.inquiry-wrap * {
  font-family: 'Noto Sans KR', sans-serif;
}

.page-title {
  font-size: 1.625rem;
  font-weight: 700;
  text-align: center;
  padding: 14px 0 18px;
}

p {
  font-size: 0.95rem;
}

.page-content {
  width: 100%;
}

.inquiry-wrap {
  max-width: 1200px;
  /* ← 여기서 제어 */
  margin: 0 auto;
  padding: 0 16px 40px;
}

/* ===== 브레드크럼 ===== */
.crumbs ol {
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 24px 0 10px;
  /* 위 간격 넉넉하게 */
  font-size: 0.92rem;
  color: #64748b;
}

.crumbs a {
  color: #64748b;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.crumbs li+li::before {
  content: "/";
  margin-right: 8px;
  color: #64748b;
}

/* ===== Hero (Q&A 톤 다운) ===== */
.hero {
  background:
    linear-gradient(rgba(13, 6, 20, .6), rgba(13, 6, 20, .6)),
    url('/src/assets/traingMain.jpeg') center 45% / 65% no-repeat;
  color: #fff;
}

.hero__inner {
  padding: 140px 16px;
  /* 위아래 여백 늘림 */
  text-align: center;
}

.hero h2 {
  font-weight: 800;
  font-size: 42px;
  /* 제목 약간 확대 */
  letter-spacing: -0.5px;
}

@media (max-width: 600px) {
  .hero__inner {
    padding: 80px 16px;
  }

  .hero h2 {
    font-size: 28px;
  }
}

/* Layout */
.inquiry-wrap {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 16px 40px;
}

.form-grid {
  display: grid;
  grid-template-columns: 160px 1fr 160px 1fr;
  gap: 14px 16px;
  border-top: 1px solid #e6e6e6;
  padding-top: 18px;
}

.label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #222;
  font-weight: 600;
  padding-left: 10px;
}

.label-right {
  justify-content: center;
  text-align: center;
}

.req {
  color: #d11;
  margin-left: 4px;
}

.field input,
.field textarea {
  width: 100%;
  border: 1px solid #dcdcdc;
  background: #fff;
  padding: 10px 12px;
  font-size: 0.95rem;
  outline: none;
}

.select-box select {
  width: 30%;
  border: 1px solid #dcdcdc;
  background: #fff;
  padding: 10px 12px;
  font-size: 0.95rem;
  outline: none;
}

.field textarea {
  resize: vertical;
  min-height: 240px;
}

.field input,
.field textarea,
.select-box select {
  box-sizing: border-box;
}

.select-box {
  position: relative;
  width: 100%;
}

.select-box select {
  appearance: none;
  padding-right: 34px;
}

.select-box .chev {
  position: absolute;
  left: 28%;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  pointer-events: none;
}

.col-span-3 {
  grid-column: span 3;
}

.col-span-4 {
  grid-column: span 4;
}

.divider {
  margin-top: 4px;
  border-top: 1px solid #e6e6e6;
  height: 1px;
}

.privacy {
  padding-top: 10px;
}

.privacy-title {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 10px;
}

.privacy-box {
  border: 1px solid #dcdcdc;
  background: #fafafa;
  padding: 14px 14px;
}

.privacy-list {
  margin-top: 10px;
  padding-left: 18px;
}

.privacy-list li {
  list-style: decimal;
  font-size: 0.95rem;
  line-height: 1.55;
  margin: 4px 0;
}

.agree-row {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 12px 0 6px;
}

.agree {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
}

.btn-link {
  border: 1px solid #dcdcdc;
  padding: 6px 10px;
  font-size: 0.9rem;
  background: #fff;
}

.error {
  color: #d11;
  margin-top: 6px;
  font-weight: 600;
}

.actions {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: center;
  gap: 12px;
  margin-top: 10px;
}

.btn {
  min-width: 160px;
  padding: 12px 14px;
  font-weight: 700;
  border: 1px solid #bdbdbd;
  cursor: pointer;
}

.btn-primary {
  background: #1d2088;
  color: #fff;
  border-color: #1d2088;
}

.btn-secondary {
  background: #9a9a9a;
  color: #fff;
  border-color: #9a9a9a;
}

/* Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: grid;
  place-items: center;
  padding: 20px;
  z-index: 9999;
}

.modal {
  width: min(980px, 100%);
  max-height: 86vh;
  background: #fff;
  border: 1px solid #dcdcdc;
  display: grid;
  grid-template-rows: auto 1fr;
}

.modal-header {
  background: #14175f;
  color: #fff;
  padding: 14px 16px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
}

.modal-title {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0;
}

.modal-close {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid #14175f;
  background: transparent;
  color: #fff;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.modal-body {
  padding: 16px;
  overflow: auto;
}

.policy-h {
  font-size: 1rem;
  font-weight: 700;
  margin: 16px 0 8px;
}

.policy-ul {
  padding-left: 18px;
  margin: 8px 0 14px;
}

.policy-ul li {
  font-size: 0.95rem;
  line-height: 1.55;
  margin: 4px 0;
}

/* 스크린샷처럼 2열 박스 */
.policy-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin: 12px 0 14px;
}

.policy-card {
  border: 1px solid #dcdcdc;
  background: #fff;
  padding: 12px;
}

.policy-card-title {
  font-weight: 700;
  margin-bottom: 8px;
}

.policy-card-row {
  font-size: 0.95rem;
  line-height: 1.6;
}

/* Responsive */
@media (max-width: 900px) {
  .form-grid {
    grid-template-columns: 120px 1fr;
  }

  .label-right {
    justify-content: flex-start;
    text-align: left;
  }

  .col-span-3,
  .col-span-4 {
    grid-column: span 1;
  }

  .actions {
    grid-template-columns: 1fr 1fr;
  }

  .policy-grid {
    grid-template-columns: 1fr;
  }
}
.sr-only {
  position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
  overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
}
.input-readonly {
  background: #f8fafc;
  color: #475569;
  cursor: not-allowed;
}
</style>
